import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=917ad4ea&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=917ad4ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917ad4ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('917ad4ea')) {
      api.createRecord('917ad4ea', component.options)
    } else {
      api.reload('917ad4ea', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=917ad4ea&scoped=true&", function () {
      api.rerender('917ad4ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XDLlP5BRivlU/JS/teamMember.vue"
export default component.exports